// extracted by mini-css-extract-plugin
export var cookies = "CookiesConsent-module--cookies--2phbn";
export var cookiesButtons = "CookiesConsent-module--cookiesButtons--zz6tX";